// NB: this component is low-level and should use minimal imports so that it can be used in landing
// pages, for instance
import * as React from "react";

type MovementEvent = React.MouseEvent<HTMLElement, MouseEvent>;

type TooltipProps = {
  renderTrigger: (
    showTooltip: (e: MovementEvent) => void,
    hideTooltip: (e: MovementEvent) => void,
    setPosition: (e: MovementEvent) => void,
  ) => React.ReactNode;
  contents: React.ReactNode;
};

const X_OFFSET = 15;
const Y_OFFSET = -20;

export default function HoverTooltip({ renderTrigger, contents }: TooltipProps): JSX.Element {
  const [visible, setVisible] = React.useState(false);
  const [position, setPosition] = React.useState([0, 0]);
  const children = React.useMemo(() => {
    const setTTPosition = (e: MovementEvent) => setPosition([e.pageX, e.pageY]);
    return renderTrigger(
      (e) => {
        setVisible(true);
        setTTPosition(e);
      },
      () => setVisible(false),
      setTTPosition,
    );
  }, [renderTrigger]);

  return (
    <>
      {visible && (
        <div
          style={{
            position: "absolute",
            left: position[0] + X_OFFSET,
            top: position[1] + Y_OFFSET,
            backgroundColor: "#2D3B54",
            color: "white",
            padding: "8px 12px",
            borderRadius: 4,
          }}
        >
          {contents}
        </div>
      )}
      {children}
    </>
  );
}
